import { createSlice } from '@reduxjs/toolkit';
import { setState } from '@app/helpers/store';

const INITIAL_STATE = {
  modalIsOpen: false,
  modalType: null,
  modalTitle: null,
  modalContent: null,
  askBennieModalIsVisible: false,
  askBennieAiIsVisible: false,
  askBennieAiInitialMessage: null,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState: INITIAL_STATE,
  reducers: {
    onModalOpen(
      state,
      {
        payload: { modalType, modalTitle, modalContent },
      },
    ) {
      setState(state, {
        modalIsOpen: true,
        modalType,
        modalTitle,
        modalContent,
      });
    },
    onModalClose: () => {
      return INITIAL_STATE;
    },
    onModalCancel: () => {
      return INITIAL_STATE;
    },
    setAskBennieModalVisibility(
      state,
      {
        payload: { isVisible },
      },
    ) {
      setState(state, { askBennieModalIsVisible: isVisible });
    },
    setAskBennieAiVisibility(
      state,
      {
        payload: { isVisible },
      },
    ) {
      setState(state, { askBennieAiIsVisible: isVisible });
    },
    setAskBennieAiInitialMessage(
      state,
      {
        payload: { initialMessage },
      },
    ) {
      setState(state, { askBennieAiInitialMessage: initialMessage });
    },
  },
});

const { actions, reducer } = modalSlice;

export const {
  onModalOpen,
  onModalClose,
  onModalCancel,
  setAskBennieModalVisibility,
  setAskBennieAiVisibility,
  setAskBennieAiInitialMessage,
} = actions;

export default reducer;
